import React, { useState, useEffect } from 'react';
import {
    Fab, TablePagination, Card, Grid, Typography, Divider, ListSubheader, Button, TextField,
    MenuItem, FormControl, FormHelperText, Select, Checkbox, ListItemText, Toolbar, Tab, Tabs,
    useMediaQuery, Paper, Table, TableContainer, TableHead, TableRow, TableCell, TableBody, IconButton,
    TableFooter, Container, CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions
} from '@mui/material';
import { Add, Close, Info, Edit, Cancel, EditNote } from '@mui/icons-material';
import { ThemeProvider, useTheme } from '@mui/material/styles';
import { tabThemeAdmin, StyledAlert } from '../TabsCore';
import { ListMtg, AddMtg, EdtMtg, ArchMtg } from '../../services/MeetingService';
import { userList } from '../../services/UserService';
import { regList } from '../../services/RegistrationService';
import { getGroups } from '../../services/GroupService';
import { adminTH, TPA, FormatDT, pBtn, nBtn, PerChk, IsoToDate, IsoToTime } from '../../common/Common';

const meetObj = {
    _id: '',
    title: '',
    type: '',
    date_time: '',
    description: '',
    link: '',
    venue: '',
    total_participants: [],
    meeting_createdby: '',
    attended_participants: [],
    summary: '',
    report_status: '',
    report_createdby: ''
}

export default function MeetingManagement() {
    const ITEM_HEIGHT = 50;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = { PaperProps: { style: { maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP } } };
    const isMobile = useMediaQuery(useTheme().breakpoints.down('sm'));
    const userId = sessionStorage.getItem('userId');
    const [now, setnow] = useState(new Date());
    const [isPast, setisPast] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [ti, setti] = useState(!PerChk('FUTURE_MEETINGS') ? '0' : !PerChk('CANCELLED_MEETINGS') ? '1' : '2')
    const [addModal, setaddModal] = useState(false);
    const [rptModal, setrptModal] = useState(false);
    const [archModal, setarchModal] = useState(null);
    const [addAlert, setaddAlert] = useState(null);
    const [editAlert, seteditAlert] = useState(null);
    const [archAlert, setarchAlert] = useState(null);
    const [pastMeets, setpastMeets] = useState([]);
    const [upcomingMeets, setupcomingMeets] = useState([]);
    const [archMeets, setarchMeets] = useState([]);
    const [activeUsers, setactiveUsers] = useState([]);
    const [memberList, setmemberList] = useState([]);
    const [groupList, setgroupList] = useState([]);
    const [rptEdit, setrptEdit] = useState(false);
    const [rptObj, setrptObj] = useState(meetObj);
    const [editDateTime, setEditDateTime] = useState(false)
    const [dateTemp, setdateTemp] = useState(now.toLocaleDateString('en-CA'));
    const [timeTemp, settimeTemp] = useState(now.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false }));
    let addDisabled = isLoading || !rptObj?.title || !rptObj?.type || (!rptObj?.link && rptObj?.type === 'Online') || (!rptObj?.venue && rptObj?.type === 'Face-to-Face') || !dateTemp || !timeTemp || rptObj?.total_participants.length < 2 || !rptObj?.description
    //let addRptDisabled = isLoading || !rptObj?.title || !rptObj?.type || (!rptObj?.link && rptObj?.type === 'Online') || (!rptObj?.venue && rptObj?.type === 'Face-to-Face') || !dateTemp || !timeTemp || rptObj?.total_participants.length < 2 || !rptObj?.description || !rptObj.summary
    let editDisabled = isLoading
    let editRptDisabled = isLoading || rptObj?.total_participants.length < 2 || !rptObj?.summary
    const [page, setPage] = useState(0);
    const [searchFilter, setsearchFilter] = useState('');
    //const checkInactive = (id) => { const user = activeUsers.find((user) => user._id === id); return user && user.status === 'Active' ? false : true };
    const userIdToName = (id) => (activeUsers?.find(u => u._id === id)?.full_name || id);
    const userIdToDetails = (id) => { const u = memberList?.find(u => u._id === id); return u ? `${u.full_name || ''} | ${u.mobile_number || ''} | ${u.support_via || ''} | ${u.notes || ''}` : id };
    const pastF = pastMeets.filter((r) => {
        return (
            r.title?.toLowerCase().includes(searchFilter) ||
            FormatDT(r.date_time)?.toLowerCase().includes(searchFilter) ||
            r.type?.toLowerCase().includes(searchFilter) ||
            r.link?.toLowerCase().includes(searchFilter) ||
            r.venue?.toLowerCase().includes(searchFilter) ||
            r.total_participants.length.toString().includes(searchFilter) ||
            r.description?.toLowerCase().includes(searchFilter) ||
            r.summary?.toLowerCase().includes(searchFilter)
        )
    }); const pastP = pastF.slice(page * 10, page * 10 + 10);
    const upcomingF = upcomingMeets.filter((r) => {
        return (
            r.title?.toLowerCase().includes(searchFilter) ||
            FormatDT(r.date_time)?.toLowerCase().includes(searchFilter) ||
            r.type?.toLowerCase().includes(searchFilter) ||
            r.link?.toLowerCase().includes(searchFilter) ||
            r.venue?.toLowerCase().includes(searchFilter) ||
            r.total_participants.length.toString().includes(searchFilter) ||
            r.description?.toLowerCase().includes(searchFilter)
        )
    }); const upcomingP = upcomingF.slice(page * 10, page * 10 + 10);
    const archF = archMeets.filter((r) => {
        return (
            r.title?.toLowerCase().includes(searchFilter) ||
            FormatDT(r.date_time)?.toLowerCase().includes(searchFilter) ||
            r.type?.toLowerCase().includes(searchFilter) ||
            r.link?.toLowerCase().includes(searchFilter) ||
            r.venue?.toLowerCase().includes(searchFilter) ||
            r.total_participants.length.toString().includes(searchFilter) ||
            r.description?.toLowerCase().includes(searchFilter)
        )
    }); const archP = archF.slice(page * 10, page * 10 + 10);

    useEffect(() => { fetchMeets() }, [])

    useEffect(() => {
        if (dateTemp && timeTemp) {
            let localInFormat = new Date(`${dateTemp}T${timeTemp}:00`);
            const locale = new Date(`${dateTemp}T${timeTemp}:00.000Z`);
            const utcOffset = locale.getTimezoneOffset() * 60 * 1000;
            const utc = new Date(locale.getTime() + utcOffset).toISOString();
            setrptObj({ ...rptObj, date_time: utc });
            setisPast(localInFormat < now.setSeconds(0, 0));
        }
    }, [dateTemp, timeTemp])

    const fetchMeets = async () => {
        try {
            const resp1 = await ListMtg(); if (resp1) {
                setpastMeets(resp1.result.filter(meet => meet.cancelled === false).filter(meet => new Date(meet.date_time) < now));
                setupcomingMeets(resp1.result.filter(meet => meet.cancelled === false).filter(meet => new Date(meet.date_time) >= now));
                setarchMeets(resp1.result.filter(meet => meet.cancelled === true));
            }
            const resp2 = await userList();
            const resp3 = await regList();
            if (resp2?.state === 'SUCCESS' && resp3?.state === 'SUCCESS') {
                const memberUsers = resp2?.result?.filter(user => user.status === 'Active' && user.roletype_key === 'SAS_MEMBER');
                const memberRegistrations = resp3?.result;
                const members = memberUsers.map(user => {
                    const register = memberRegistrations.find(item => item.user_id === user._id);
                    return { ...(register || {}), ...(user || {}) };
                });
                setactiveUsers(resp2?.result?.filter(user => user.status === 'Active'));
                setmemberList(members);
            }
            const resp4 = await getGroups(); if (resp4?.state === 'SUCCESS') {
                setgroupList(resp4?.result?.sort((a, b) => (a.name || "").localeCompare(b.name || "")))
            }
        }
        catch (error) { console.log(error) }
    }

    const AddReport = async () => {
        setIsLoading(true);
        try {
            let addObj = {
                title: rptObj.title.trim(),
                type: rptObj.type,
                date_time: rptObj.date_time || now.toISOString(),
                description: rptObj.description && rptObj.description.trim(),
                link: rptObj.link,
                venue: rptObj.venue.trim(),
                total_participants: rptObj.total_participants,
                meeting_createdby: userId,
                /* attended_participants: isPast ? rptObj.attended_participants : [],
                summary: isPast ? rptObj.summary : '',
                report_status: isPast ? 'Published' : '',
                report_createdby: isPast ? userId : '' */
            }
            const resp = await AddMtg(addObj); if (resp) {
                fetchMeets(); setaddModal(false);
                setaddAlert('success');
                setTimeout(() => { setaddAlert(null) }, 3000);
            }
        }
        catch (error) {
            console.log('Error--', error); setaddAlert('error');
            setTimeout(() => { setaddAlert(null) }, 3000);
        }
        setIsLoading(false); setrptObj(meetObj);
    }

    const EditReport = async (id) => {
        setIsLoading(true);
        try {
            let editObj = {
                date_time: rptObj.date_time || now.toISOString(),
                total_participants: rptObj.total_participants,
                attended_participants: rptObj.attended_participants,
                summary: rptObj.summary && rptObj.summary.trim(),
                report_status: 'Published',
                report_createdby: userId
            }
            const resp = await EdtMtg(id, editObj); if (resp) {
                fetchMeets(); setrptModal(false); seteditAlert('success')
                setTimeout(() => { seteditAlert(null) }, 3000);
            }
        }
        catch (error) {
            console.log('Error--', error); seteditAlert('error');
            setTimeout(() => { seteditAlert(null) }, 3000);
        }
        setIsLoading(false); setrptObj(meetObj);
    }

    const ArchReport = async (id) => {
        setIsLoading(true);
        try {
            const resp = await ArchMtg(id); if (resp) {
                setrptModal(false); setrptEdit(false); setrptObj(meetObj);
                fetchMeets(); setarchAlert('success'); setarchModal(null);
                setTimeout(() => { setarchAlert(null) }, 3000);
            }
        } catch (error) {
            console.log('Error--', error); setarchAlert('error');
            setTimeout(() => { setarchAlert(null) }, 3000);
        }
        setIsLoading(false);
    }

    const groupedMembers = new Set(groupList?.flatMap(g => g.members.map(m => m.userId)) ?? []);
    const ungroupedMembers = memberList?.filter(m => !groupedMembers.has(m._id))?.sort((a, b) => (a.full_name || '').localeCompare(b.full_name || ''));
    const adminUsers = activeUsers?.filter(u => u.roletype_key === 'SAS_ADMIN' || u.roletype_key === 'SUPER_ADMIN')?.sort((a, b) => (a.full_name || '').localeCompare(b.full_name || ''));

    return (<>
        <Fab hidden={PerChk('ADD_MEETING')} title='Create a meeting' onClick={() => { setnow(new Date()); setaddModal(true); }}
            sx={{ position: 'fixed', bottom: 40, right: 20 }}><Add sx={{ color: '#fff' }} /></Fab>

        {addAlert && <StyledAlert severity={addAlert}>{addAlert === 'success' ? 'Meeting added' : 'Failed to add meeting'}</StyledAlert>}
        {editAlert && <StyledAlert severity={editAlert}>{editAlert === 'success' ? 'Meeting updated' : 'Failed to update Meeting'}</StyledAlert>}
        {archAlert && <StyledAlert severity={archAlert}>{archAlert === 'success' ? 'Meeting cancelled' : 'Failed to cancel meeting'}</StyledAlert>}

        <Toolbar><ThemeProvider theme={tabThemeAdmin}><Tabs value={ti} onChange={(e, v) => { setti(v); setsearchFilter(''); setPage(0); }}>
            <Tab value={'0'} label='Upcoming' hidden={PerChk('FUTURE_MEETINGS')} />
            <Tab value={'1'} label='Past' hidden={PerChk('CANCELLED_MEETINGS')} />
            <Tab value={'2'} label='Cancelled' hidden={PerChk('PAST_MEETINGS')} />
        </Tabs></ThemeProvider></Toolbar>

        <Container><Grid container>
            {((ti === '0' && upcomingMeets.length > 0) || (ti === '1' && pastMeets.length > 0) || (ti === '2' && archMeets.length > 0)) &&
                <Grid item xs={12}
                    sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center', mr: 2, mb: 1 }}>
                    <FormControl sx={{ width: '125px' }}><TextField label='Search' value={searchFilter}
                        size='small' onChange={(e) => setsearchFilter(e.target.value?.toLowerCase())} /></FormControl>
                </Grid>
            }

            <Grid item xs={12}>{
                (ti === '0' && upcomingF.length > 0) ?
                    <Paper sx={{ width: '100%', overflow: 'hidden' }} hidden={PerChk('FUTURE_MEETINGS')}><TableContainer sx={{ maxHeight: 440 }}><Table>
                        <TableHead sx={adminTH}><TableRow>
                            <TableCell sx={{ color: '#fff' }}>Title</TableCell>
                            <TableCell sx={{ color: '#fff' }}>Date & Time</TableCell>
                            <TableCell sx={{ color: '#fff' }}>Type</TableCell>
                            <TableCell sx={{ color: '#fff' }}>Link/Venue</TableCell>
                            <TableCell sx={{ color: '#fff' }}>Description</TableCell>
                            <TableCell />
                        </TableRow></TableHead>

                        <TableBody>{upcomingP.sort((a, b) => new Date(b.date_time) - new Date(a.date_time)).map((r, i) => (<TableRow key={i} onClick={() => { setrptObj(r); setrptModal(true); }}
                            sx={{ '&:hover': { cursor: 'pointer', bgcolor: '#ddd' } }}>
                            <TableCell><Typography>{r.title}</Typography></TableCell>
                            <TableCell><Typography style={{ width: "maxContent" }}>{FormatDT(r.date_time)}</Typography></TableCell>
                            <TableCell><Typography>{r.type}</Typography></TableCell>
                            <TableCell><Typography>{r.link || r.venue}</Typography></TableCell>
                            <TableCell><Typography>{r.description}</Typography></TableCell>
                            <TableCell onClick={(e) => e.stopPropagation()} align='right'>
                                <IconButton hidden={PerChk('EDIT_MEETING')} title='Edit meeting' onClick={() => {
                                    setrptObj(r);
                                    ; setrptEdit(true); setrptModal(true); setEditDateTime(true);
                                }}><Edit sx={{ color: '#b5651d' }} /></IconButton>
                                <IconButton hidden={PerChk('CANCEL_MEETING')} title='Cancel meeting' onClick={() => setarchModal(r._id)}><Cancel sx={{ color: '#c00' }} /></IconButton>
                            </TableCell>
                        </TableRow>))}</TableBody>

                        <TableFooter><TableRow><TablePagination count={upcomingF.length}
                            page={page} rowsPerPage={10}
                            sx={{ '.MuiTablePagination-displayedRows': { display: 'none' } }}
                            onPageChange={(e, p) => { setPage(p) }} rowsPerPageOptions={[]}
                            ActionsComponent={TPA} /></TableRow></TableFooter>
                    </Table></TableContainer></Paper>
                    : (ti === '1' && pastF.length > 0) ?
                        <Paper sx={{ width: '100%', overflow: 'hidden' }} hidden={PerChk('CANCELLED_MEETINGS')}><TableContainer sx={{ maxHeight: 440 }}><Table>
                            <TableHead sx={adminTH}><TableRow>
                                <TableCell sx={{ color: '#fff' }}>Title</TableCell>
                                <TableCell sx={{ color: '#fff' }}>Date & Time</TableCell>
                                <TableCell sx={{ color: '#fff' }}>Type</TableCell>
                                <TableCell sx={{ color: '#fff' }}>Link/Venue</TableCell>
                                <TableCell sx={{ color: '#fff' }}>Description</TableCell>
                                <TableCell />
                            </TableRow></TableHead>

                            <TableBody>{pastP.sort((a, b) => new Date(b.date_time) - new Date(a.date_time)).map((r, i) => (<TableRow key={i} onClick={() => { setrptObj(r); setrptModal(true); }}
                                sx={{ '&:hover': { cursor: 'pointer', bgcolor: '#ddd' } }}>
                                <TableCell><Typography>{r.title}</Typography></TableCell>
                                <TableCell><Typography style={{ width: "maxContent" }}>{FormatDT(r.date_time)}</Typography></TableCell>
                                <TableCell><Typography>{r.type}</Typography></TableCell>
                                <TableCell><Typography>{r.link || r.venue}</Typography></TableCell>
                                <TableCell><Typography>{r.description}</Typography></TableCell>
                                <TableCell onClick={(e) => e.stopPropagation()} align='right'>
                                    <IconButton title='Edit meeting' onClick={() => { setrptObj(r); setrptEdit(true); setrptModal(true); setEditDateTime(false) }}><EditNote sx={{ color: '#b5651d' }} /></IconButton>
                                </TableCell>
                            </TableRow>))}</TableBody>

                            <TableFooter><TableRow><TablePagination count={pastF.length}
                                page={page} rowsPerPage={10}
                                sx={{ '.MuiTablePagination-displayedRows': { display: 'none' } }}
                                onPageChange={(e, p) => { setPage(p) }} rowsPerPageOptions={[]}
                                ActionsComponent={TPA} /></TableRow></TableFooter>
                        </Table></TableContainer></Paper>
                        : (ti === '2' && archF.length > 0) ?
                            <Paper sx={{ width: '100%', overflow: 'hidden' }} hidden={PerChk('PAST_MEETINGS')}><TableContainer sx={{ maxHeight: 440 }}><Table>
                                <TableHead sx={adminTH}><TableRow>
                                    <TableCell sx={{ color: '#fff' }}>Title</TableCell>
                                    <TableCell sx={{ color: '#fff' }}>Date & Time</TableCell>
                                    <TableCell sx={{ color: '#fff' }}>Type</TableCell>
                                    <TableCell sx={{ color: '#fff' }}>Link/Venue</TableCell>
                                    <TableCell sx={{ color: '#fff' }}>Description</TableCell>
                                </TableRow></TableHead>

                                <TableBody>{archP.sort((a, b) => new Date(b.date_time) - new Date(a.date_time)).map((r, i) => (<TableRow key={i} onClick={() => { setrptObj(r); setrptModal(true); }}
                                    sx={{ '&:hover': { cursor: 'pointer', bgcolor: '#ddd' } }}>
                                    <TableCell><Typography>{r.title}</Typography></TableCell>
                                    <TableCell><Typography style={{ width: "maxContent" }}>{FormatDT(r.date_time)}</Typography></TableCell>
                                    <TableCell><Typography>{r.type}</Typography></TableCell>
                                    <TableCell><Typography>{r.link || r.venue}</Typography></TableCell>
                                    <TableCell><Typography>{r.description}</Typography></TableCell>
                                </TableRow>))}</TableBody>

                                <TableFooter><TableRow><TablePagination count={pastF.length}
                                    page={page} rowsPerPage={10}
                                    sx={{ '.MuiTablePagination-displayedRows': { display: 'none' } }}
                                    onPageChange={(e, p) => { setPage(p) }} rowsPerPageOptions={[]}
                                    ActionsComponent={TPA} /></TableRow></TableFooter>
                            </Table></TableContainer></Paper>
                            :
                            <Typography variant='h6' sx={{ textAlign: 'center' }}>{searchFilter ? 'No results for your search' : 'No records'}</Typography>
            }</Grid>
        </Grid></Container >

        <Dialog open={archModal}>
            <DialogTitle sx={{ mb: '5px', borderBottom: '1px solid #b5651d' }}><Typography variant='h6'>Confirmation</Typography></DialogTitle>
            <DialogContent><Typography sx={{ mb: '20px' }}>Are you sure you want to cancel this meeting?</Typography></DialogContent>
            <DialogActions style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', gap: '5px' }}>
                <Button sx={pBtn} onClick={() => setarchModal(null)} disabled={isLoading}>No</Button>
                <Button sx={nBtn} onClick={() => ArchReport(archModal)} disabled={isLoading}>{isLoading ? <CircularProgress size={24} /> : 'Yes'}</Button>
            </DialogActions>
        </Dialog>

        <Dialog fullWidth open={addModal}>
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #b5651d', mb: '5px' }}>
                <Typography variant='h6'>Add New Meeting</Typography>
                <Close sx={{ color: '#fff', bgcolor: 'red', borderRadius: '15%', cursor: 'pointer' }} onClick={() => {
                    setaddModal(false); setrptObj(meetObj); setdateTemp(now.toLocaleDateString('en-CA'));
                    settimeTemp(now.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false }));
                }} />
            </DialogTitle>

            <DialogContent><Card><Grid container spacing={2}>
                <Grid item xs={isMobile ? 12 : 8}><TextField required label='Title' value={rptObj?.title}
                    onChange={(e) => setrptObj({ ...rptObj, title: e.target.value })} /></Grid>

                <Grid item xs={isMobile ? 12 : 2}><TextField required type='date' label='Meeting Date' onKeyDown={(e) => e.preventDefault()}
                    value={dateTemp} onChange={(e) => setdateTemp(e.target.value)} /></Grid>

                <Grid item xs={isMobile ? 12 : 2}><TextField required type='time' label='Meeting Time' onKeyDown={(e) => e.preventDefault()}
                    value={timeTemp} onChange={(e) => settimeTemp(e.target.value)} /></Grid>

                <Grid item xs={isMobile ? 12 : 3}><TextField required select label='Meeting Type' value={rptObj?.type}
                    onChange={(e) => setrptObj({ ...rptObj, type: e.target.value, link: '', venue: '' })}>
                    <MenuItem value='Online'>Online</MenuItem>
                    <MenuItem value='Face-to-Face'>Face-to-Face</MenuItem>
                </TextField></Grid>

                <Grid item xs={isMobile ? 12 : 9}>{
                    rptObj?.type === 'Online' ? <TextField required label='Link' value={rptObj?.link}
                        onChange={(e) => setrptObj({ ...rptObj, link: e.target.value })} />
                        : rptObj?.type === 'Face-to-Face' ? <TextField required label='Venue' value={rptObj?.venue}
                            onChange={(e) => setrptObj({ ...rptObj, venue: e.target.value })} />
                            : <TextField disabled value={'Select meeting type first'} />
                }</Grid>

                <Grid item xs={12}>
                    <FormControl fullWidth>
                        <FormHelperText>Invite participants</FormHelperText>
                        <Select multiple value={rptObj?.total_participants} onChange={(e) => setrptObj({ ...rptObj, total_participants: e.target.value, attended_participants: [] })}
                            renderValue={(selected) => { const selectedUsers = selected.map((id) => userIdToName(id)); return `${selected.length} selected: ${selectedUsers.join(', ')}`; }} MenuProps={MenuProps}>
                            {groupList.filter(g => g?.members?.length > 0).flatMap(g => [
                                <ListSubheader key={`${g._id}-header`}>
                                    <Checkbox
                                        indeterminate={
                                            g.members.some(m => rptObj?.total_participants?.includes(m.userId)) &&
                                            !g.members.every(m => rptObj?.total_participants?.includes(m.userId))
                                        }
                                        checked={g.members.every(m => rptObj?.total_participants?.includes(m.userId))}
                                        onChange={(e) => {
                                            const groupIds = g.members.map(m => m.userId);
                                            if (e.target.checked) {
                                                setrptObj(prev => ({ ...prev, total_participants: Array.from(new Set([...(prev.total_participants || []), ...groupIds])) }));
                                            } else {
                                                setrptObj(prev => ({ ...prev, total_participants: (prev.total_participants || []).filter(id => !groupIds.includes(id)) }));
                                            }
                                        }}
                                    />
                                    {g?.name}
                                </ListSubheader>,
                                ...g?.members?.sort((a, b) => (userIdToName(a.userId) || "").localeCompare(userIdToName(b.userId) || ""))?.map(m => (
                                    <MenuItem key={m.userId} value={m.userId} sx={{ ml: 2, my: -2 }}>
                                        <Checkbox size="small" checked={rptObj?.total_participants?.some(r => r === m.userId)} />
                                        <ListItemText>{userIdToDetails(m.userId)}</ListItemText>
                                    </MenuItem>
                                )),
                                <Divider variant='middle' />
                            ])}

                            <ListSubheader>
                                <Checkbox
                                    indeterminate={
                                        ungroupedMembers.some(m => rptObj?.total_participants?.includes(m._id)) &&
                                        !ungroupedMembers.every(m => rptObj?.total_participants?.includes(m._id))
                                    }
                                    checked={ungroupedMembers.every(m => rptObj?.total_participants?.includes(m._id))}
                                    onChange={(e) => {
                                        const ids = ungroupedMembers.map(m => m._id);
                                        if (e.target.checked) {
                                            setrptObj(prev => ({ ...prev, total_participants: Array.from(new Set([...(prev.total_participants || []), ...ids])) }));
                                        } else {
                                            setrptObj(prev => ({ ...prev, total_participants: (prev.total_participants || []).filter(id => !ids.includes(id)) }));
                                        }
                                    }}
                                />
                                Unassigned
                            </ListSubheader>
                            {ungroupedMembers.map(m => (
                                <MenuItem key={m._id} value={m._id} sx={{ ml: 2, my: -2 }}>
                                    <Checkbox size="small" checked={rptObj?.total_participants?.includes(m._id)} />
                                    <ListItemText>
                                        {m.full_name} | {m.mobile_number} | {m.support_via} | {m.notes}
                                    </ListItemText>
                                </MenuItem>
                            ))}
                            <Divider variant='middle' />

                            <ListSubheader>
                                <Checkbox
                                    indeterminate={
                                        adminUsers.some(u => rptObj?.total_participants?.includes(u._id)) &&
                                        !adminUsers.every(u => rptObj?.total_participants?.includes(u._id))
                                    }
                                    checked={adminUsers.every(u => rptObj?.total_participants?.includes(u._id))}
                                    onChange={(e) => {
                                        const ids = adminUsers.map(u => u._id);
                                        if (e.target.checked) {
                                            setrptObj(prev => ({ ...prev, total_participants: Array.from(new Set([...(prev.total_participants || []), ...ids])) }));
                                        } else {
                                            setrptObj(prev => ({ ...prev, total_participants: (prev.total_participants || []).filter(id => !ids.includes(id)) }));
                                        }
                                    }}
                                />
                                Admins
                            </ListSubheader>
                            {adminUsers.map(user => (
                                <MenuItem key={user._id} value={user._id} sx={{ ml: 2, my: -2 }}>
                                    <Checkbox size="small" checked={rptObj?.total_participants?.includes(user._id)} />
                                    <ListItemText>{user.full_name} | {user.mobile_number}</ListItemText>
                                </MenuItem>
                            ))}
                        </Select>
                        {rptObj?.total_participants.length < 2 && (<FormHelperText error>Select at least 2 participants</FormHelperText>)}
                    </FormControl>
                </Grid>

                <Grid item xs={12}><TextField required multiline rows={4} label='Description' value={rptObj?.description}
                    helperText={`${rptObj?.description?.split(/\s+/).length || 0}/500`}
                    onChange={(e) => {
                        const wordCount = e.target.value.split(/\s+/).length;
                        if (wordCount <= 500) { setrptObj({ ...rptObj, description: e.target.value }) }
                    }} /></Grid>

                {/*isPast && <>
                    <Grid item xs={12}><Typography variant='h6' sx={{ mb: 0 }}>Add report</Typography></Grid>

                    <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'row' }}><Typography>
                        <Info /> Meeting report is also required since meeting has already taken place
                    </Typography></Grid>

                    <Grid item xs={12}><FormControl fullWidth>
                        <FormHelperText>Attendance</FormHelperText>
                        <Select multiple value={rptObj?.attended_participants} onChange={(e) => setrptObj({ ...rptObj, attended_participants: e.target.value })}
                            renderValue={(selected) => {
                                const selectedUsers = selected.map((id) => {
                                    const user = activeUsers.find((user) => user._id === id);
                                    return user ? user.full_name : id;
                                }); return `${selected.length} selected: ${selectedUsers.join(', ')}`;
                            }} MenuProps={MenuProps}>
                            {activeUsers.filter(user => rptObj?.total_participants.includes(user._id)).map((user) => (<MenuItem key={user._id} value={user._id}>
                                <Checkbox checked={rptObj?.attended_participants.indexOf(user._id) > -1} />
                                <ListItemText primary={user.full_name} />
                            </MenuItem>))}
                        </Select>
                    </FormControl></Grid>

                    <Grid item xs={12}><TextField required multiline rows={4} label='Summary' value={rptObj?.summary}
                        helperText={`${rptObj?.summary?.split(/\s+/).length || 0}/500`}
                        onChange={(e) => {
                            const wordCount = e.target.value.split(/\s+/).length;
                            if (wordCount <= 500) { setrptObj({ ...rptObj, summary: e.target.value }) }
                        }} /></Grid>
                </>*/}
            </Grid></Card></DialogContent>

            <DialogActions sx={{ display: 'flex', justifyContent: 'flex-end', gap: '5px' }}>
                <Button sx={pBtn} onClick={AddReport} disabled={addDisabled || isLoading}
                    title='Add report after filling all necessary fields'>
                    {isLoading ? <CircularProgress size={24} /> : 'Save'}
                </Button>
            </DialogActions>
        </Dialog>

        <Dialog fullWidth open={rptModal}>
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', mb: '5px', borderBottom: '1px solid #b5651d' }}>
                <Typography variant='h6' sx={{ mb: 0 }}>{rptObj?.title}</Typography>
                <Close sx={{ color: '#fff', bgcolor: 'red', borderRadius: '15%', cursor: 'pointer' }} onClick={() => { setrptModal(false); setrptEdit(false); setrptObj(meetObj); }} />
            </DialogTitle>

            <DialogContent><Card sx={{ gap: '10px' }}>
                <Typography><b>Type</b>: {rptObj?.type}</Typography>

                <Typography>
                    {rptObj?.type === 'Face-to-Face' && <><b>Venue: </b>{rptObj?.venue}</>}
                    {rptObj?.type === 'Online' && <><b>Link: </b><a href={rptObj?.link}>{rptObj?.link}</a></>}
                </Typography>

                <Typography><b>Date & time</b>: {FormatDT(rptObj?.date_time)}</Typography>

                <Typography style={{ display: 'block', wordBreak: 'break-word' }}>
                    <b>Meeting Description: </b>{rptObj?.description}
                </Typography>

                {rptEdit && editDateTime && <>
                    <Grid container spacing={2}>
                        <Grid item xs={isMobile ? 12 : 3}><TextField required type='date' label='Meeting Date' onKeyDown={(e) => e.preventDefault()}
                            value={IsoToDate(rptObj.date_time)} onChange={(e) => setdateTemp(e.target.value)} /></Grid>

                        <Grid item xs={isMobile ? 12 : 3}><TextField required type='time' label='Meeting Time' onKeyDown={(e) => e.preventDefault()}
                            value={IsoToTime(rptObj.date_time)} onChange={(e) => settimeTemp(e.target.value)} /></Grid>
                    </Grid>
                </>}

                {rptEdit ? <>
                    <FormControl fullWidth>
                        <FormHelperText>Invite participants</FormHelperText>
                        <Select multiple value={rptObj?.total_participants} onChange={(e) => setrptObj({ ...rptObj, total_participants: e.target.value, attended_participants: [] })}
                            renderValue={(selected) => { const selectedUsers = selected.map((id) => userIdToName(id)); return `${selected.length} selected: ${selectedUsers.join(', ')}`; }} MenuProps={MenuProps}>
                            {groupList.filter(g => g?.members?.length > 0).flatMap(g => [
                                <ListSubheader key={`${g._id}-header`}>
                                    <Checkbox
                                        indeterminate={
                                            g.members.some(m => rptObj?.total_participants?.includes(m.userId)) &&
                                            !g.members.every(m => rptObj?.total_participants?.includes(m.userId))
                                        }
                                        checked={g.members.every(m => rptObj?.total_participants?.includes(m.userId))}
                                        onChange={(e) => {
                                            const groupIds = g.members.map(m => m.userId);
                                            if (e.target.checked) {
                                                setrptObj(prev => ({ ...prev, total_participants: Array.from(new Set([...(prev.total_participants || []), ...groupIds])) }));
                                            } else {
                                                setrptObj(prev => ({ ...prev, total_participants: (prev.total_participants || []).filter(id => !groupIds.includes(id)) }));
                                            }
                                        }}
                                    />
                                    {g?.name}
                                </ListSubheader>,
                                ...g?.members?.sort((a, b) => (userIdToName(a.userId) || "").localeCompare(userIdToName(b.userId) || ""))?.map(m => (
                                    <MenuItem key={m.userId} value={m.userId} sx={{ ml: 2, my: -2 }}>
                                        <Checkbox size="small" checked={rptObj?.total_participants?.some(r => r === m.userId)} />
                                        <ListItemText>{userIdToDetails(m.userId)}</ListItemText>
                                    </MenuItem>
                                )),
                                <Divider variant='middle' />
                            ])}

                            <ListSubheader>
                                <Checkbox
                                    indeterminate={
                                        ungroupedMembers.some(m => rptObj?.total_participants?.includes(m._id)) &&
                                        !ungroupedMembers.every(m => rptObj?.total_participants?.includes(m._id))
                                    }
                                    checked={ungroupedMembers.every(m => rptObj?.total_participants?.includes(m._id))}
                                    onChange={(e) => {
                                        const ids = ungroupedMembers.map(m => m._id);
                                        if (e.target.checked) {
                                            setrptObj(prev => ({ ...prev, total_participants: Array.from(new Set([...(prev.total_participants || []), ...ids])) }));
                                        } else {
                                            setrptObj(prev => ({ ...prev, total_participants: (prev.total_participants || []).filter(id => !ids.includes(id)) }));
                                        }
                                    }}
                                />
                                Unassigned
                            </ListSubheader>
                            {ungroupedMembers.map(m => (
                                <MenuItem key={m._id} value={m._id} sx={{ ml: 2, my: -2 }}>
                                    <Checkbox size="small" checked={rptObj?.total_participants?.includes(m._id)} />
                                    <ListItemText>
                                        {m.full_name} | {m.mobile_number} | {m.support_via} | {m.notes}
                                    </ListItemText>
                                </MenuItem>
                            ))}
                            <Divider variant='middle' />

                            <ListSubheader>
                                <Checkbox
                                    indeterminate={
                                        adminUsers.some(u => rptObj?.total_participants?.includes(u._id)) &&
                                        !adminUsers.every(u => rptObj?.total_participants?.includes(u._id))
                                    }
                                    checked={adminUsers.every(u => rptObj?.total_participants?.includes(u._id))}
                                    onChange={(e) => {
                                        const ids = adminUsers.map(u => u._id);
                                        if (e.target.checked) {
                                            setrptObj(prev => ({ ...prev, total_participants: Array.from(new Set([...(prev.total_participants || []), ...ids])) }));
                                        } else {
                                            setrptObj(prev => ({ ...prev, total_participants: (prev.total_participants || []).filter(id => !ids.includes(id)) }));
                                        }
                                    }}
                                />
                                Admins
                            </ListSubheader>
                            {adminUsers.map(user => (
                                <MenuItem key={user._id} value={user._id} sx={{ ml: 2, my: -2 }}>
                                    <Checkbox size="small" checked={rptObj?.total_participants?.includes(user._id)} />
                                    <ListItemText>{user.full_name} | {user.mobile_number}</ListItemText>
                                </MenuItem>
                            ))}
                        </Select>
                        {rptObj?.total_participants.length < 2 && (<FormHelperText error>Select at least 2 participants</FormHelperText>)}
                    </FormControl>
                    {ti === '1' && <>
                        <Divider sx={{ my: '5px' }} />

                        <Typography variant='h6' sx={{ mb: '2px' }}>Report</Typography>

                        <FormControl fullWidth>
                            <FormHelperText sx={{ gap: '5px' }}>
                                <b style={{ fontSize: 'large' }}>Attendance</b> <small>{rptObj?.attended_participants.length} of {rptObj?.total_participants.length} invited participants attended. {rptObj?.total_participants.length - rptObj?.attended_participants.length} absent.</small>
                            </FormHelperText>
                            <Select disabled={!rptEdit} multiple value={rptObj?.attended_participants} onChange={(e) => setrptObj({ ...rptObj, attended_participants: e.target.value })}
                                renderValue={(selected) => {
                                    const selectedUsers = selected.map((id) => {
                                        const user = activeUsers.find((user) => user._id === id);
                                        return user ? user.full_name : id;
                                    }); return `${selected.length} selected: ${selectedUsers.join(', ')}`;
                                }}>
                                {activeUsers.filter(user => rptObj?.total_participants.includes(user._id)).map((user) => (<MenuItem key={user._id} value={user._id}>
                                    <Checkbox checked={rptObj?.attended_participants.indexOf(user._id) > -1} />
                                    <ListItemText primary={user.full_name} />
                                </MenuItem>))}
                            </Select>
                        </FormControl>

                        <TextField required disabled={!rptEdit} multiline rows={4} label='Summary' value={rptObj?.summary}
                            helperText={`${rptObj?.summary?.split(/\s+/).length || 0}/500`}
                            onChange={(e) => {
                                const wordCount = e.target.value.split(/\s+/).length;
                                if (wordCount <= 500) { setrptObj({ ...rptObj, summary: e.target.value }) }
                            }} />
                    </>}
                </> : <>
                    <Typography>
                        <b>Participants invited: </b>{activeUsers.filter(user => rptObj?.total_participants.includes(user._id)).map(user => user.full_name).join(', ')}
                    </Typography>

                    {ti === '1' && <>
                        <Divider sx={{ my: '5px' }} />

                        <Typography variant='h6' sx={{ mb: '2px' }}>Report</Typography>

                        <Typography>
                            <b>Participants attended: </b>{activeUsers.filter(user => rptObj?.attended_participants.includes(user._id)).map(user => user.full_name).join(', ')}
                        </Typography>

                        <Typography><b>Report summary: </b>{rptObj?.summary}</Typography>
                    </>}

                    {ti === '2' && <Typography variant='h6' sx={{ color: 'red', m: 0 }}>This meeting has been cancelled.</Typography>}
                </>}
            </Card></DialogContent>

            {rptEdit && <DialogActions sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button onClick={() => EditReport(rptObj?._id)} disabled={ti === '1' ? editRptDisabled || isLoading : editDisabled || isLoading} sx={pBtn}>
                    {isLoading ? <CircularProgress size={24} /> : 'Save'}</Button>
            </DialogActions>}
        </Dialog>
    </>)
}